import { action } from "typesafe-actions"

export function signInSuccessUser({ name, email }: { name: string, email: string }) {
    return action('@user/SIGN_IN_SUCCESS', { name, email })
}
export function signOutUser() {
    return action('@auth/SIGN_OUT')
}
